import React from "react";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const selectYears = startYear =>
  Array.from({ length: 102 }, (v, index) => {
    // eslint-disable-next-line no-param-reassign
    index += startYear;

    return index;
  });

const renderSelect = ({ month, onMonthSelect, onYearSelect }, startYear) => {
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  return (
    <div className="select-position">
      <div>
        <select
          className="date-select"
          value={month.getMonth()}
          onChange={e => {
            const newDate = new Date(month);
            newDate.setMonth(parseInt(e.target.value));
            onMonthSelect(newDate, e.target.value);
          }}
        >
          {months.map((label, value) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select
          className="date-select"
          value={month.getFullYear()}
          onChange={e => {
            const newDate = new Date(month);
            newDate.setFullYear(parseInt(e.target.value));
            onYearSelect(newDate, e.target.value);
          }}
        >
          {selectYears(startYear).map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

// Current year minus legal age (18) minus 100 years
// minus 1 year (to account for index starting from 0)}
export const startYear = new Date().getFullYear() - 119;
export const renderSelectBirthday = ({ ...props }) =>
  renderSelect({ ...props }, startYear);
export const renderSelectDate = ({ ...props }) =>
  renderSelect({ ...props }, 1980);
